import api from '@src/api';

export const getThemes = ({ temporary, ssrHeaders }) =>
  api.get('school/theme/', { temporary }, { ssrHeaders });

export const updateThemes = (payload) => api.post('school/theme/', payload);
